/* eslint-disable no-shadow */
function time12(time) {
    let pm = ' am';
    let hrs = time.getHours();
    if (hrs == 0) {
        hrs = 12;
    } else if (hrs > 12) {
        hrs = hrs - 12; pm = ' pm';
    } else if (hrs == 12) { pm = ' pm'; }
    let mins = time.getMinutes().toString();
    if (mins.length == 1) { mins = '0' + mins; }
    return (
        hrs + ':' + mins + pm
    );
}
function hrs(time) {
    let hrs = time.getHours();
    if (hrs == 0) {
        hrs = 12;
    } else if (hrs > 12) {
        hrs = hrs - 12;
    }
    return (
        hrs.toString()
    );
}
function hrs24(hrs, ampm) {
    hrs = Number(hrs);
    let hrs24;
    if (ampm == 'am') {
        if (hrs == 12) {
            hrs24 = 0;
        } else {
            hrs24 = hrs;
        }
    } else if (ampm == 'pm') {
        if (hrs == 12) {
            hrs24 = hrs;
        } else {
            hrs24 = hrs + 12;
        }
    }
    return (
        hrs24
    );
}
function mins(time) {
    let mins = time.getMinutes().toString();
    if (mins.length == 1) { mins = '0' + mins; }
    return (
        mins
    );
}
function ampm(time) {
    let pm = 'am';
    let hrs = time.getHours();
    if (hrs >= 12) { pm = 'pm'; }
    return (
        pm
    );
}

function roundUp(num, precision) {
    let res = 'wrong entry';
    num = Number(num);
    precision = Number(precision);
    if (!isNaN(precision)) {
        num = num / precision;
        res = Math.round(num);
        res = res * precision;
    }
    return res;
}

function month3(date) {
    return (months[date.getMonth()]);
}

function dateTime(date) {
    return (month3(date) + ' ' + date.getDate() + ' ' + time12(date));
}
const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

export { time12, hrs, hrs24, mins, ampm, roundUp, month3, dateTime };
